import { IntegrationSource } from '../../constants';

export interface SettingsCourseData {
  id: string;
  courseId: string;
  courseName: string;
  courseDescription?: string;
  recurrence: number;
  numberOfAssociatedAttributes: number;
  associatedAttributeDefinitions: string[];
  organizationIntegrationName: string;
  organizationIntegrationAbbreviation: string;
  organizationIntegrationIntegrationSource: IntegrationSource;
  faculties: string[];
  facultiesAsString: string;
  rowId: string;
  name: string;
  description: string;
  associatedAttribute: string[];
}

export class SettingsCourse {
  id: string | undefined;
  rowId: string | undefined;
  courseId: string | undefined;
  name: string | undefined;
  courseName?: string;
  description: string | undefined;
  recurrence: number | undefined;
  numberOfAssociatedAttributes: number | undefined;
  associatedAttribute: string[] | undefined;
  organizationIntegrationName: string | undefined;
  organizationIntegrationAbbreviation: string | undefined;
  organizationIntegrationIntegrationSource: IntegrationSource | undefined;
  faculties: string[] | undefined;
  facultiesAsString: string | undefined;

  /**
   * True for an OLC catalogue course, false/undefined for one from the organisation's own
   * integration. The two live in unrelated id spaces and are saved through separate fields, so the
   * editor has to keep them apart even though it shows them in one list.
   */
  isCatalogue?: boolean;

  constructor(data?: SettingsCourseData) {
    if (data) {
      this.id = data.id;
      this.rowId = data.id;
      this.courseId = data.courseId;
      this.name = data.courseName;
      this.courseName = data.courseName;
      this.description = data.courseDescription;
      this.recurrence = data.recurrence;
      this.numberOfAssociatedAttributes = data.numberOfAssociatedAttributes;
      this.associatedAttribute = data.associatedAttributeDefinitions;
      this.organizationIntegrationName = data.organizationIntegrationName;
      this.organizationIntegrationAbbreviation = data.organizationIntegrationAbbreviation;
      this.organizationIntegrationIntegrationSource = data.organizationIntegrationIntegrationSource;
      this.faculties = data.faculties;
      // Carried through the constructor so clones (toStandardAttribute, any re-hydration) keep it;
      // losing it turns a catalogue course into an integration id and the save is rejected.
      this.isCatalogue = (data as { isCatalogue?: boolean }).isCatalogue;
      this.facultiesAsString = data.facultiesAsString;
    }
  }
}
